<template>
  <CreatePolicyModal
    :modal-active="modalActive"
    :loading="isLoading"
    @close="emits('close')"
    @submit="createPolicy"
  />
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

import { storeToRefs } from 'pinia'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'

import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import PATHS from '@/router/paths'

import CreatePolicyModal from '@/modules/company/Policy/components/CreatePolicyModal.vue'
import type { CreatePolicyFormData } from '@/modules/company/Policy/components/CreatePolicyModal.vue'

const router = useRouter()
const toast = useToast()
const { notifyError } = useErrorToast()
const dsPolicyStore = useDsPolicyStore()

const { isLoading } = storeToRefs(dsPolicyStore)

const emits = defineEmits<{ close: [] }>()

defineProps<{ modalActive: boolean }>()

const createPolicy = async (formData: CreatePolicyFormData) => {
  try {
    const createdDsPolicy = await dsPolicyStore.createDsPolicy({
      name: formData.name,
      companyOwnerId: Number(formData.companyId)
    })

    if (createdDsPolicy?.id) {
      await dsPolicyStore.fetchDsPolicyById(createdDsPolicy.id)
      router.push(`${PATHS.MANAGE_DOCTOR_AUTHORIZATION_POLICIES}/${createdDsPolicy.id}`)
      toast.success('Política criada com sucesso!')
    }
  } catch (error) {
    console.error(error)
    notifyError(error, 'Não foi possível criar a política de restrição.')
  } finally {
    emits('close')
  }
}
</script>
